import useCompanyService from './useCompanyService';

export default useCompanyService;
